import vc from "./iv.png"
const DialogProp = [
    {
        btnlogo: vc,
        btntitle: "Start Video Call?",
        btncontent: "Sorry,The Feature is Not Available For Now",
        btnno: "No",
        btnyes: "Yes"
    }
]

export default DialogProp;